// Native CRM surface; state and canonical session persistence belong to the
// CallsWorkspace. Only one conversation engine is mounted for this contact.
import { ReactiveCallGuidance, type ReactiveGuidanceProps } from './ReactiveCallGuidance'
export function CallsWorkspaceReactiveBridge(props: ReactiveGuidanceProps) {
  return <ReactiveCallGuidance {...props} />
}
